const BRAND_FETCH_CLIENT_ID = '1idm7MwQPYYK-g3Zcre';

function normalizeUrl(url: string) {
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}

export function parseDomainForBrandfetch(url: string) {
  try {
    const hostname = new URL(normalizeUrl(url.trim())).hostname;

    return hostname.startsWith('www.') ? hostname.slice(4) : hostname;
  } catch {
    return '';
  }
}

export function getBrandfetchImageUrls(url: string) {
  const domain = parseDomainForBrandfetch(url);

  if (!domain) {
    return undefined;
  }

  return {
    domain,
    iconUrl: `https://cdn.brandfetch.io/${domain}/icon/fallback/404?c=${BRAND_FETCH_CLIENT_ID}`,
    logoUrl: `https://cdn.brandfetch.io/${domain}/logo/fallback/404?c=${BRAND_FETCH_CLIENT_ID}`,
  };
}
